import React from 'react';
import { css } from '@emotion/core';

const lineCss = css`
  flex-basis: 100%;
  height: 0px;
`;

/**
 * This will allow you to force a flex item to the next line
 */
const LineBreak = () => <div aria-hidden="true" css={lineCss} />;

export default LineBreak;
